import type { User } from './user';
import type { OriginalMsg } from './message';

export enum SessionCategoryPrefix {
  Single = 'P_',
  Group = 'GN_',
}

export enum SessionRemoved {
  NO = 0,
  YES = 1,
}

export enum SessionIsCreator {
  CREATOR = 1,
  RECEIVER = 0,
}

export interface CreateGroupSessionResponse {
  fail_group_ids: string[];
  invite_total_count: number;
  session: OriginalSession;
}

export enum SessionOperate {
  MARKED_UNREAD = 0b00_00_00_01,
  MUTED = 0b00_00_01_00,
  MUTED_AT_ALL = 0b00_01_00_00,
  PINNED = 0b01_00_00_00,
}
export const DefaultCollapseGroupId = 'default_collapse_group';

export interface OriginalSession {
  collapse_group_id: string;
  receiver_id: string;
  at_message_list: string[];
  chat_id: string;
  name: string;
  user_info: User | undefined;
  avatar: string;
  avatar_color: string;
  last_message: OriginalMsg | undefined;
  sequence: number;
  last_read_sequence: number;
  local_sequence: number;
  is_creator: SessionIsCreator;
  created_at: number;
  update_at: number;
  unread_count: number;
  expire_duration: number;
  removed: SessionRemoved;
  operate: SessionOperate;
}

export enum AccountType {
  Robot = 'robot',
}
